<div class="user-form-container">
  <div class="header-actions">
    <button mat-button class="back-link" (click)="cancel()">
      <mat-icon>arrow_back_ios</mat-icon> Terug naar overzicht
    </button>
    <button
      mat-flat-button
      color="primary"
      [disabled]="(userForm && !userForm.valid) || (rideTimeForm && !rideTimeForm.valid) || loading()"
      [class.spinner]="loading()"
      (click)="save()"
    >
      {{ isEditing() ? 'Bijwerken' : 'Toevoegen' }}
    </button>
  </div>
  <h3 class="form-title">{{ user()?.title }}</h3>

  <form [formGroup]="userForm" class="user-form">
    @if (data.particularities.length > 0) {
      <p class="dialog-subtitle">Bijzonderheden</p>
      <div class="icons">
        @for (particularity of data.particularities; track particularity) {
          <div
            class="icon"
            [ngClass]="{ active: userForm.value.particularityIds.includes(particularity.id) }"
            [matTooltip]="particularity.name ?? ''"
            role="button"
            tabindex="0"
            [attr.aria-label]="
              userForm.value.particularityIds.includes(particularity.id)
                ? 'Bijzonderheid deselecteren: ' + (particularity.name ?? '')
                : 'Bijzonderheid selecteren: ' + (particularity.name ?? '')
            "
            [attr.aria-pressed]="userForm.value.particularityIds.includes(particularity.id)"
            (click)="toggleParticularity(particularity.id!)"
            (keydown.enter)="toggleParticularity(particularity.id!)"
            (keydown.space)="$event.preventDefault(); toggleParticularity(particularity.id!)"
          >
            <mat-icon [svgIcon]="particularity.id ?? ''"></mat-icon>
          </div>
        }
      </div>
    }
    <p class="dialog-subtitle">Locatie</p>
    <div class="form-row">
      <div class="form-col">
        <mat-form-field class="type-select">
          <mat-label>Ophalen</mat-label>
          <mat-select
            #fromTypeSelect
            formControlName="fromType"
            required
            (selectionChange)="onInputTypeChange('from', $event)"
            (openedChange)="focusNextInputField('from', $event)"
          >
            @for (type of locationTypes; track type) {
              <mat-option [value]="type.val">
                {{ type.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (!fromHidden()) {
          <app-ors-address-autocomplete
            #orsFromInput
            formControlName="from"
            [label]="'Adres'"
            [placeholder]="'mijn straat 1, mijn dorp'"
            [required]="true"
            [autoActiveFirstOption]="true"
          ></app-ors-address-autocomplete>
        }
        @if (!standardFromHidden()) {
          <mat-form-field>
            <mat-label>Adres</mat-label>
            <input
              #fromStandardAddressInput
              type="search"
              formControlName="fromSearch"
              matInput
              [matAutocomplete]="fromStandardAddressAuto"
              required
            />
            <mat-autocomplete
              #fromStandardAddressAuto="matAutocomplete"
              (optionSelected)="standardAddressSelected($event, 'from')"
            >
              @for (address of addressesFrom(); track address) {
                <mat-option [value]="address.id"> {{ address.name }}, {{ address.address }} </mat-option>
              }
              @if (nothingFound()) {
                <mat-option class="no-options" disabled> Geen overeenkomende adressen gevonden </mat-option>
              }
            </mat-autocomplete>
            @if (this.userForm.controls.from.hasError('required')) {
              <mat-error>Dit veld is verplicht.</mat-error>
            }
          </mat-form-field>
        }
        @if (!recentFromHidden()) {
          <mat-form-field>
            <mat-label>Adres</mat-label>
            <mat-select #fromLatestAddressInput formControlName="from" required>
              <mat-select-trigger>
                {{ userForm.value.from }}
              </mat-select-trigger>
              @for (destination of recentDestinations(); track destination) {
                <mat-option class="recent-destination" [value]="destination">
                  <span>{{ destination }}</span>
                  <button
                    type="button"
                    mat-icon-button
                    aria-label="Recent ophaaladres verwijderen"
                    (click)="deleteRecentDestination(destination); $event.stopPropagation()"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </mat-option>
              }
              @if (recentDestinations().length === 0) {
                <mat-option class="no-options" disabled> Geen recente adressen bekend </mat-option>
              }
            </mat-select>
            @if (this.userForm.controls.from.hasError('required')) {
              <mat-error>Dit veld is verplicht.</mat-error>
            }
          </mat-form-field>
        }
      </div>

      <div class="form-col">
        <mat-form-field class="type-select">
          <mat-label>Afzetten</mat-label>
          <mat-select
            #toTypeSelect
            formControlName="toType"
            required
            (selectionChange)="onInputTypeChange('to', $event)"
            (openedChange)="focusNextInputField('to', $event)"
          >
            @for (type of locationTypes; track type) {
              <mat-option [value]="type.val">
                {{ type.name }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        @if (!toHidden()) {
          <app-ors-address-autocomplete
            #orsToInput
            formControlName="to"
            [label]="'Adres'"
            [placeholder]="'mijn straat 1, mijn dorp'"
            [required]="true"
            [autoActiveFirstOption]="true"
          ></app-ors-address-autocomplete>
        }
        @if (!standardToHidden()) {
          <mat-form-field>
            <mat-label>Adres</mat-label>
            <input
              #toStandardAddressInput
              type="search"
              formControlName="toSearch"
              matInput
              [matAutocomplete]="toStandardAddressAuto"
              required
            />
            <mat-autocomplete
              #toStandardAddressAuto="matAutocomplete"
              (optionSelected)="standardAddressSelected($event, 'to')"
            >
              @for (address of addressesTo(); track address) {
                <mat-option [value]="address.id"> {{ address.name }}, {{ address.address }} </mat-option>
              }
              @if (nothingFound()) {
                <mat-option class="no-options" disabled> Geen overeenkomende adressen gevonden </mat-option>
              }
            </mat-autocomplete>
            @if (this.userForm.controls.to.hasError('required')) {
              <mat-error>Dit veld is verplicht.</mat-error>
            }
          </mat-form-field>
        }
        @if (!recentToHidden()) {
          <mat-form-field>
            <mat-label>Adres</mat-label>
            <mat-select #toLatestAddressInput formControlName="to" required>
              <mat-select-trigger>
                {{ userForm.value.to }}
              </mat-select-trigger>
              @for (destination of recentDestinations(); track destination) {
                <mat-option class="recent-destination" [value]="destination">
                  {{ destination }}
                  <button
                    type="button"
                    mat-icon-button
                    aria-label="Recent afzetadres verwijderen"
                    (click)="deleteRecentDestination(destination); $event.stopPropagation()"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </mat-option>
              }
              @if (recentDestinations().length === 0) {
                <mat-option class="no-options" disabled> Geen recente adressen bekend </mat-option>
              }
            </mat-select>
            @if (this.userForm.controls.to.hasError('required')) {
              <mat-error>Dit veld is verplicht.</mat-error>
            }
          </mat-form-field>
        }
      </div>
    </div>

    <!-- @if (data.planType !== PlanType.Automatic || !data.forceRideStartEnd) {
      <form [formGroup]="rideTimeForm">
        <div class="form-field-group-wrapper">
          <div class="dialog-subtitle">Ophaalmoment</div>
          <div class="form-field-group">
            <mat-form-field class="hour">
              <mat-label>Uur</mat-label>
              <mat-select formControlName="startHour">
                @for (hour of hours(); track hour) {
                  @if (hour <= endHour && hour >= startHour) {
                    <mat-option [value]="hour">{{ hour }}</mat-option>
                  }
                }
              </mat-select>
              @if (this.rideTimeForm.controls.startHour.hasError('required')) {
                <mat-error>Dit veld is verplicht.</mat-error>
              }
            </mat-form-field>
            <mat-form-field class="minute">
              <mat-label>Minuten</mat-label>
              <mat-select formControlName="startMinute">
                @if (rideTimeForm.controls.startMinute.value % 5 !== 0) {
                  <mat-option [value]="rideTimeForm.controls.startMinute.value" style="display: none">{{
                    rideTimeForm.controls.startMinute.value < 10
                      ? '0' + rideTimeForm.controls.startMinute.value
                      : rideTimeForm.controls.startMinute.value
                  }}</mat-option>
                }
                @for (minute of minutes(); track minute) {
                  @if (displayMinute(minute.val, 'start')) {
                    <mat-option [value]="minute.val">{{ minute.text }}</mat-option>
                  }
                }
              </mat-select>
              @if (this.rideTimeForm.controls.startMinute.hasError('required')) {
                <mat-error>Dit veld is verplicht.</mat-error>
              }
            </mat-form-field>
          </div>
          <div class="dialog-subtitle">Afzetmoment</div>
          <div class="form-field-group">
            <mat-form-field class="hour">
              <mat-label>Uur</mat-label>
              <mat-select formControlName="endHour">
                @for (hour of hours(); track hour) {
                  @if (hour <= endHour && hour >= startHour) {
                    <mat-option [value]="hour">{{ hour }}</mat-option>
                  }
                }
              </mat-select>
              @if (this.rideTimeForm.controls.endHour.hasError('required')) {
                <mat-error>Dit veld is verplicht.</mat-error>
              }
            </mat-form-field>
            <mat-form-field class="minute">
              <mat-label>Minuten</mat-label>
              <mat-select formControlName="endMinute">
                @if (rideTimeForm.controls.endMinute.value % 5 !== 0) {
                  <mat-option [value]="rideTimeForm.controls.endMinute.value" style="display: none">{{
                    rideTimeForm.controls.endMinute.value < 10
                      ? '0' + rideTimeForm.controls.endMinute.value
                      : rideTimeForm.controls.endMinute.value
                  }}</mat-option>
                }
                @for (minute of minutes(); track minute) {
                  @if (displayMinute(minute.val, 'end')) {
                    <mat-option [value]="minute.val">{{ minute.text }}</mat-option>
                  }
                }
              </mat-select>
              @if (this.rideTimeForm.controls.endMinute.hasError('required')) {
                <mat-error>Dit veld is verplicht.</mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        @if (invalidTimeCombination) {
          <mat-error>Het ophaalmoment moet plaatsvinden voor het afzetmoment.</mat-error>
        }
        @if (maxRideMinutesExceeded) {
          <mat-error
            >De rit van een passagier mag niet langer dan
            {{ dataStore.generalSettings.maxPassengerRideMinutes ?? 45 }} minuten duren.</mat-error
          >
        }
      </form>
    } -->
    @if (!data.forceRideStartEnd) {
      <p class="dialog-subtitle">In- en uitstapduur (in minuten)</p>
      <div class="form-row">
        <mat-form-field class="form-col">
          <mat-label>Instapduur</mat-label>
          <input formControlName="vehicleEntryDuration" matInput type="text" autocomplete="off" />
          @if (userForm.controls.vehicleEntryDuration.hasError('max')) {
            <mat-error>De instapduur mag niet meer dan 15 minuten zijn.</mat-error>
          } @else if (userForm.controls.vehicleEntryDuration.hasError('numberInput')) {
            <mat-error>Vul een geldige waarde in.</mat-error>
          }
        </mat-form-field>
        <mat-form-field class="form-col">
          <mat-label>Uitstapduur</mat-label>
          <input formControlName="vehicleExitDuration" matInput type="text" autocomplete="off" />
          @if (userForm.controls.vehicleExitDuration.hasError('max')) {
            <mat-error>De uitstapduur mag niet meer dan 15 minuten zijn.</mat-error>
          } @else if (userForm.controls.vehicleExitDuration.hasError('numberInput')) {
            <mat-error>Vul een geldige waarde in.</mat-error>
          }
        </mat-form-field>
      </div>
    }

    @if (showRideProduct() && (data.planType !== PlanType.Automatic || !data.forceRideStartEnd)) {
      <p class="dialog-subtitle">Ritprijs</p>
      <mat-form-field>
        <mat-label>Aangepaste ritprijs</mat-label>
        <mat-select formControlName="rideProduct">
          <mat-option [value]="'none'">Geen </mat-option>
          @for (product of products(); track product) {
            <mat-option [value]="product.id">{{ product.name }} </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }

    @if (planningComments() || driverComments()) {
      <p class="dialog-subtitle">Opmerkingen</p>
      @if (planningComments()) {
        <mat-form-field>
          <mat-label>Opmerking (Planner)</mat-label>
          <textarea formControlName="remarks" matInput></textarea>
        </mat-form-field>
      }
      @if (driverComments()) {
        <mat-form-field>
          <mat-label>Opmerking (Voor chauffeur)</mat-label>
          <textarea formControlName="commentsForDriver" matInput></textarea>
        </mat-form-field>
      }
    }
  </form>
</div>
